import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.4903 4.4231C12.1858 4.25187 11.8142 4.25187 11.5097 4.4231L6.03975 7.49997L12.0002 10.8526L17.9603 7.49999L12.4903 4.4231ZM19 9.20985L13.0002 12.5848V19.29L18.4903 16.2019C18.8051 16.0247 19 15.6916 19 15.3303V9.20985ZM11.0002 19.2902V12.5848L5 9.20981V15.3303C5 15.6916 5.19486 16.0247 5.50974 16.2019L11.0002 19.2902ZM5.01911 6.92588L4.52922 6.05495C3.58459 6.58631 3 7.58586 3 8.66968V15.3303C3 16.4141 3.58459 17.4137 4.52922 17.945L10.5292 21.32C11.4425 21.8337 12.5575 21.8337 13.4708 21.32L19.4708 17.945C20.4154 17.4137 21 16.4141 21 15.3303V8.66968C21 7.58586 20.4154 6.58631 19.4708 6.05495L13.4708 2.67995C12.5575 2.16625 11.4425 2.16625 10.5292 2.67995L4.52922 6.05495L5.01911 6.92588Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }